import Comment from './Comment'
export * from './index.d'

export default Comment
